import { FormGroup, Validators } from '@angular/forms';
import { addDays } from 'date-fns';
import { TissueCollectionType } from '../../../../shared/services/request.service';
import { SettingsService } from 'research.web.settings';
var SamplingNeedsFormComponent = /** @class */ (function () {
    function SamplingNeedsFormComponent(settingsService) {
        this.settingsService = settingsService;
        this.projectedTaskConfigurations = [];
        this.tissueTypes = [];
        this.assays = [];
        this.tissueCollectionTypes = [];
        this.growthStages = [];
        this.GROWTH_STAGE = SamplingDateCalculationStrategy.GrowthStage;
        this.DAYS_AFTER_PLANTING = SamplingDateCalculationStrategy.DaysAfterPlanting;
        this.settings = this.settingsService.get("_appSettings");
    }
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "assay", {
        get: function () {
            return this.samplingNeeds.get('assay');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "tissueType", {
        get: function () {
            return this.samplingNeeds.get('tissueType');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "tissueCollectionType", {
        get: function () {
            return this.samplingNeeds.get('tissueCollectionType');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "samplingDateCalculationStrategy", {
        get: function () {
            return this.samplingNeeds.get('samplingDateCalculationStrategy');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "growthStage", {
        get: function () {
            return this.samplingNeeds.get('growthStage');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "daysAfterPlanting", {
        get: function () {
            return this.samplingNeeds.get('daysAfterPlanting');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "displayTissueCollectionType", {
        get: function () {
            return this.assay.valid && this.tissueType.valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "displaySamplingDateCalculationFields", {
        get: function () {
            return this.displayTissueCollectionType && this.tissueCollectionType.value === TissueCollectionType.Custom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "displayGrowthStage", {
        get: function () {
            return this.samplingDateCalculationStrategy.value === SamplingDateCalculationStrategy.GrowthStage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "displayDaysAfterPlanting", {
        get: function () {
            return this.samplingDateCalculationStrategy.value === SamplingDateCalculationStrategy.DaysAfterPlanting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "displaySamplingDate", {
        get: function () {
            return this.displayDaysAfterPlanting && this.daysAfterPlanting.valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "doesSamplingConfigurationRuleExist", {
        get: function () {
            var _this = this;
            return this.projectedTaskConfigurations.some(function (s) { return s.laboratoryAssayId === _this.assay.value && s.tissueTypeId === _this.tissueType.value; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "filteredTissueCollectionTypes", {
        get: function () {
            if (this.displayTissueCollectionType && this.doesSamplingConfigurationRuleExist)
                return this.tissueCollectionTypes;
            return this.tissueCollectionTypes.filter(function (t) { return t.id === TissueCollectionType.Custom; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsFormComponent.prototype, "samplingDate", {
        get: function () {
            var samplingDateOffset = this.daysAfterPlanting.value;
            if (this.requestDetails.crop === this.settings.wheatCropId) {
                samplingDateOffset += this.settings.NumberOfDaysInDormancy;
            }
            return addDays(this.requestDetails.plantingDate, samplingDateOffset);
        },
        enumerable: true,
        configurable: true
    });
    SamplingNeedsFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assay.valueChanges.subscribe(function () { return _this.updateTissueCollectionType(); });
        this.tissueType.valueChanges.subscribe(function () { return _this.updateTissueCollectionType(); });
        this.tissueCollectionType.valueChanges.subscribe(function (t) { return _this.tissueCollectionTypeValueChanged(t); });
        this.samplingDateCalculationStrategy.valueChanges.subscribe(function (s) { return _this.updateSamplingDateCalculationFields(s); });
    };
    SamplingNeedsFormComponent.prototype.updateTissueCollectionType = function () {
        var defaultTissueCollectionType = TissueCollectionType.Custom;
        if (this.doesSamplingConfigurationRuleExist) {
            defaultTissueCollectionType = TissueCollectionType.Standard;
        }
        this.tissueCollectionType.setValue(defaultTissueCollectionType);
    };
    SamplingNeedsFormComponent.prototype.tissueCollectionTypeValueChanged = function (tissueCollectionType) {
        if (tissueCollectionType === TissueCollectionType.Standard) {
            this.clearGrowthStage();
            this.clearDaysAfterPlanting();
        }
        else {
            this.updateSamplingDateCalculationFields(this.samplingDateCalculationStrategy.value);
        }
    };
    SamplingNeedsFormComponent.prototype.updateSamplingDateCalculationFields = function (samplingDateCalculationStrategy) {
        if (samplingDateCalculationStrategy === SamplingDateCalculationStrategy.GrowthStage) {
            this.enableGrowthStage();
            this.clearDaysAfterPlanting();
        }
        else {
            this.clearGrowthStage();
            this.enableDaysAfterPlanting();
        }
    };
    SamplingNeedsFormComponent.prototype.clearGrowthStage = function () {
        this.growthStage.setValue(null);
        this.growthStage.clearValidators();
        this.growthStage.disable();
        this.growthStage.updateValueAndValidity();
    };
    SamplingNeedsFormComponent.prototype.clearDaysAfterPlanting = function () {
        this.daysAfterPlanting.setValue(null);
        this.daysAfterPlanting.clearValidators();
        this.daysAfterPlanting.disable();
        this.daysAfterPlanting.updateValueAndValidity();
    };
    SamplingNeedsFormComponent.prototype.enableGrowthStage = function () {
        this.growthStage.enable();
        this.growthStage.setValidators(Validators.required);
        this.growthStage.updateValueAndValidity();
    };
    SamplingNeedsFormComponent.prototype.enableDaysAfterPlanting = function () {
        this.daysAfterPlanting.enable();
        this.daysAfterPlanting.setValidators([Validators.required, Validators.min(0)]);
        this.daysAfterPlanting.updateValueAndValidity();
    };
    return SamplingNeedsFormComponent;
}());
export { SamplingNeedsFormComponent };
export var SamplingDateCalculationStrategy;
(function (SamplingDateCalculationStrategy) {
    SamplingDateCalculationStrategy[SamplingDateCalculationStrategy["GrowthStage"] = 0] = "GrowthStage";
    SamplingDateCalculationStrategy[SamplingDateCalculationStrategy["DaysAfterPlanting"] = 1] = "DaysAfterPlanting";
})(SamplingDateCalculationStrategy || (SamplingDateCalculationStrategy = {}));



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/sampling-needs/sampling-needs-form/sampling-needs-form.component.ts.pre-build-optimizer.js